import { CheckboxField_default } from "./chunk-M7W7GYDI.js";
import { CheckableGroupContext } from "./chunk-YG26ROD3.js";
import { __objRest, __spreadValues } from "./chunk-ORMEWXMH.js";

// src/components/CheckableGroup/CheckableGroup.Field.tsx
import React, { forwardRef, useContext } from "react";
import clsx from "clsx";
var DEFAULT_COMPONENT = CheckboxField_default;
var CheckableGroupField = forwardRef((_a, ref) => {
  var _b = _a,
    {
      as,
      className
    } = _b,
    rest = __objRest(_b, ["as", "className"]);
  const Component = as || DEFAULT_COMPONENT;
  const {
    name,
    variant,
    disabled
  } = useContext(CheckableGroupContext);
  return /* @__PURE__ */React.createElement(Component, __spreadValues({
    ref,
    name,
    variant,
    disabled,
    className: clsx("pd-checkable-group__field", className)
  }, rest));
});
var CheckableGroup_Field_default = CheckableGroupField;
export { CheckableGroup_Field_default };